import { Skeleton, Text, TextSize } from '@vizit/atoms';
import { LightbulbIcon } from '@vizit/icons';

interface RecommendationsExplainProps {
  /**
   * The category name to display in the explanation text
   */
  categoryName?: string;
}

/**
 * RecommendationsExplain component displays a tooltip explaining the recommendations
 * Designed to be used with Caption's infoCustomComponent prop
 */
export function RecommendationsExplain({ categoryName }: RecommendationsExplainProps) {
  const isCategoryLoaded = !!categoryName;

  return (
    <div className="bg-primary flex flex-col gap-5 p-5 shadow-lg w-[284px] text-left">
      <div className="w-14 h-14 flex items-center justify-center border border-primary p-2">
        <LightbulbIcon size={16} className="text-tertiary" />
      </div>

      <div className="flex flex-col gap-4">
        <Text size={TextSize.Sm} className="text-primary" showEllipsis={false}>
          These recommendations target the
          <span className="font-medium"> highest-impact revenue opportunities for your product page</span>, based on
          Vizit’s analysis of the content patterns that drive conversion in the
          {isCategoryLoaded ? (
            <> {categoryName} </>
          ) : (
            <Skeleton className="inline-block ml-3 h-8 w-50 align-middle" variant="square" />
          )}
          category.
        </Text>
      </div>
    </div>
  );
}

export type { RecommendationsExplainProps };
